import { cva } from 'class-variance-authority';

export const selectContainerClasses = cva(
  'relative mb-2 flex items-center overflow-visible rounded-xl border bg-white focus-within:ring-offset-1',
  {
    variants: {
      state: {
        success: 'border-success-900',
        error: 'border-danger-500',
        idle: 'charcoal-alpha-50',
        disabled: 'charcoal-alpha-50'
      }
    },
    defaultVariants: {
      state: 'idle'
    }
  }
);

export const selectInputClasses = cva(
  `text-charcoal-500 w-full appearance-none border-0 bg-transparent text-ellipsis` +
    `z-10 flex max-h-screen min-w-full items-center pl-4 focus:ring-0 focus:outline-none`,
  {
    variants: {
      isFluid: {
        true: 'mt-3 h-10',
        false: 'h-14'
      }
    },
    defaultVariants: {
      isFluid: false
    }
  }
);

export const selectedValueClasses = cva('truncate', {
  variants: {
    hasValue: {
      true: 'text-charcoal-500',
      false: 'text-pebble-500'
    }
  },
  defaultVariants: {
    hasValue: false
  }
});

export const wrapperClasses = cva([`relative w-full`], {
  variants: {
    isDisabled: {
      true: 'opacity-60',
      false: 'opacity-100'
    }
  },
  defaultVariants: {
    isDisabled: false
  }
});

export const topSectionClasses = cva('flex flex-col space-y-1 pb-2');

export const iconWrapperClasses = cva(
  'absolute right-0 flex items-center p-3 transition-transform duration-200 ease-in-out',
  {
    variants: {
      isOpen: {
        true: 'rotate-180',
        false: 'rotate-0'
      }
    },
    defaultVariants: {
      isOpen: false
    }
  }
);

export const fluidLabelClasses = cva('text-charcoal-400 absolute top-1 left-4');

export const dropdownListClasses = cva(
  'border-pebble-300 absolute top-full z-[1000] mt-1 max-h-60 w-full overflow-y-auto rounded-md border bg-white shadow-lg'
);

export const listItemClasses = cva(
  'hover:bg-pebble-100 cursor-pointer px-3 py-2 text-sm transition-colors',
  {
    variants: {
      isSelected: {
        true: 'bg-primary-50 text-primary-900 font-medium'
      }
    }
  }
);
